export const errorMessages = {
  'firstName' : 'This is not a vaild first name',
  'lastName' : 'This is not a vaild last name',
  'email' : 'This is not a vaild email address',
  'phoneNumber' : 'This is not a vaild phone number',
  'jobTitle' : 'This is not a vaild job title',
  'company' : 'This is not a vaild company'
};
